import React from 'react'
import { Link } from 'react-router-dom';
import './footer.css';

function Footer() {
  return (
    <div className='footer'>
      <div className='container mt-4'>
        <div className='row'>
            <div className='col-md-8'>
                <ul className='footer-nav'>
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about">About Us</Link></li>
                    <li><Link to="/service">Service</Link></li>
                    <li><Link to="/privatetour">Private Tour</Link></li>
                    <li><Link to="/ourfleet">Our Fleet</Link></li>
                    <li><Link to="/faq">FAQ</Link></li>
                    <li><Link to="/contact">Contact Us</Link></li>
                </ul>
            </div>
            <div className='col-md-4 footer-contact mt-3 text-right'>
            <ul className="stayconnect clearfix">

				{/* <li><a href="#"></a></li>
				<li className="two"><a href="#"></a></li> */}
				<li className="three"><a href="https://www.instagram.com/ltsjapan/?igsh=NWcwZzVodTZuemE5" target='_blanlk'></a></li>
				{/* <li className="gplus"><a href="#"></a></li> 
				<li className="twitter"><a href="#"></a></li>*/}
				<li className="fb"><a href="https://www.facebook.com/people/Legions-Travel-Service-Japan/61556839600387/" target='_blank'></a></li>
			</ul>
              </div> 
        </div>
      </div>
      <div className='site-info'>Copyright © 2024 Japan Land Service. All rights reserved.</div>
    </div>

  )
}

export default Footer
